export const LEFT_AXES_VIEW = 'left_axes_view';
export const RIGHT_AXES_VIEW = 'right_axes_view';
